import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-validate-dialog',
  templateUrl: './validate-dialog.component.html',
  styleUrls: ['./validate-dialog.component.scss']
})
export class ValidateDialogComponent implements OnInit {

  public okButton = {
    label: '',
    code: ''
  };
  public cancelButton = {
    label: '',
    code: ''
  };
  public otherButton = {
    label: '',
    code: ''
  };
  public title = '';
  public message = '';
  public icon = 'warning';

  constructor(private dialogRef: MatDialogRef<ValidateDialogComponent>, @Inject(MAT_DIALOG_DATA) data) {
    if (data.title) {
      this.title = data.title;
    }
    if (data.message) {
      this.message = data.message;
    }
    if (data.ok) {
      this.okButton.label = data.ok.label;
      this.okButton.code = data.ok.code;
    }
    if (data.cancel) {
      this.cancelButton.label = data.cancel.label;
      this.cancelButton.code = data.cancel.code;
    }
    if (data.other) {
      this.otherButton.label = data.other.label;
      this.otherButton.code = data.other.code;
    }
  }

  ngOnInit(): void {
  }

  close(code: string): void {
    this.dialogRef.close(code);
  }

}
